import { memo, useState } from 'react'
import { motion, type Variants } from 'framer-motion'
import { HighlightLogo } from '@highlight/ui'
import { unsecureRandom } from '@shared/utils/random'

const DISPLAY_COUNT = 4

const allSuggestions: Array<string> = [
  'What action items came out of my last meeting?',
  'Help me write interview questions for this role',
  'What are my open Linear tickets right now?',
  "What did we discuss in yesterday's standup?",
  'Summarize the key points from this document',
  'Help me draft a follow-up email',
  'What are the blockers on my current project?',
  'Write a quick status update for my team',
  'Help me prepare talking points for my next 1:1',
  'What deadlines do I have coming up this week?',
]

const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08 },
  },
}

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: [0.25, 0.1, 0.25, 1] },
  },
}

function shuffle<T>(arr: Array<T>): Array<T> {
  const copy = [...arr]
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(unsecureRandom() * (i + 1))
    ;[copy[i], copy[j]] = [copy[j], copy[i]]
  }
  return copy
}

interface ChatSuggestionsProps {
  onSuggestionClick: (prompt: string) => void
}

export const ChatSuggestions = memo(function ChatSuggestions({ onSuggestionClick }: ChatSuggestionsProps) {
  const [suggestions] = useState(() => shuffle(allSuggestions).slice(0, DISPLAY_COUNT))

  return (
    <div className="relative flex flex-1 flex-col items-start justify-end gap-2.5 px-3 pb-2">
      <div className="text-foreground-placeholder pointer-events-none absolute inset-x-0 bottom-[160px] top-0 flex items-center justify-center">
        <HighlightLogo size="xl" aria-hidden>
          <HighlightLogo.Icon />
        </HighlightLogo>
      </div>
      {/* <motion.div */}
      {/*   className="relative flex flex-col items-start gap-2.5" */}
      {/*   variants={containerVariants} */}
      {/*   initial="hidden" */}
      {/*   animate="visible" */}
      {/* > */}
      {/*   {suggestions.map((suggestion) => ( */}
      {/*     <motion.button */}
      {/*       key={suggestion} */}
      {/*       variants={itemVariants} */}
      {/*       className="text-foreground-secondary bg-background border-current/10 border-border cursor-pointer rounded-lg border px-2.5 py-1.5 text-left text-[13px] font-normal leading-tight transition-colors" */}
      {/*       onClick={() => onSuggestionClick(suggestion)} */}
      {/*     > */}
      {/*       {suggestion} */}
      {/*     </motion.button> */}
      {/*   ))} */}
      {/* </motion.div> */}
    </div>
  )
})
